import { createAction } from 'app-components/flux/core/actionHelpers';

export const createJobStatus = createAction(
  'CREATE_JOB_STATUS',
  (payload) => payload,
  (payload, meta) => meta,
);
export const createJobStatusSuccess = createAction('CREATE_JOB_STATUS_SUCCESS');
export const createJobStatusFailure = createAction('CREATE_JOB_STATUS_FAILURE');

export const deleteJobStatus = createAction('DELETE_JOB_STATUS');
export const deleteJobStatusSuccess = createAction('DELETE_JOB_STATUS_SUCCESS');
export const deleteJobStatusFailure = createAction('DELETE_JOB_STATUS_FAILURE');
